import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { DatabaseBackup, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { saveBlob } from "@/components/payroll/bankUtils";

export const BackupReminderPanel = () => {
  const [last, setLast] = useState(undefined);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/backup/last").then((r) => setLast(r.data.last || null)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (last === undefined) return null;
  const days = last ? Math.floor((Date.now() - new Date(last.at).getTime()) / 86400000) : null;
  if (last && days < 30) return null;
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.get("/admin/backup?include_files=false", { responseType: "blob", timeout: 0 });
      saveBlob(r, "akat_yedek.zip");
      toast.success("Yedek indirildi");
      load();
    } catch { toast.error("Yedek alınamadı"); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-[1600px] mx-auto px-6 pt-4" data-testid="backup-reminder-panel">
      <div className="border border-sky-300 bg-sky-50 rounded-xl px-4 py-3 flex items-center gap-3 flex-wrap">
        <DatabaseBackup size={16} className="text-sky-700" />
        <span className="text-sm font-semibold text-sky-900" data-testid="backup-reminder-text">
          {last ? `Son yedek ${days} gün önce alındı · 30 günü geçti` : "Henüz hiç yedek alınmadı"}
        </span>
        <span className="text-xs text-sky-800">Dosyalar dahil yedek için Ayarlar → Yedek Al</span>
        <button type="button" onClick={run} disabled={busy} data-testid="backup-reminder-download"
          className="ml-auto inline-flex items-center gap-1.5 px-3 py-1.5 bg-sky-700 hover:bg-sky-800 text-white rounded-lg text-xs font-semibold disabled:opacity-50">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <DatabaseBackup size={13} />} Şimdi Yedek Al
        </button>
      </div>
    </div>
  );
};
